import request from '@/utils/request'

// 获取当前登录用户信息  代办处/经销商
export function getLoginUserInfo() {
    return request({
        url: '/agent/getLoginUserInfo',
        method: 'get'
    })
}

// 修改当前登录用户信息  代办处
export function editLoginUserInfo(data) {
    return request({
        url: '/agent/editLoginUserInfo',
        method: 'post',
        data
    })
}

// 经销商资料管理  代办处
export function getMembers(query) {
    return request({
        url: '/agent/getMembers',
        method: 'get',
        params: query
    })
}

// 经销商信息查看  代办处
export function miMemberView(query) {
    return request({
        url: '/agent/miMemberView',
        method: 'get',
        params: query
    })
}

// 代办处奖金查询  代办处
export function bdBonusHisAgents(query) {
    return request({
        url: '/agent/bdBonusHisAgents',
        method: 'get',
        params: query
    })
}

// 代办处补货数量  代办处
export function agentWareStocks(query) {
    return request({
        url: '/agent/agentWareStocks',
        method: 'get',
        params: query
    })
}

// 周转补货单列表  代办处
export function poOrderAgents(query) {
    return request({
        url: '/agent/poOrderAgents',
        method: 'get',
        params: query
    })
}

// 周转补货单查看  代办处
export function poOrderAgentView(query) {
    return request({
        url: '/agent/poOrderAgentView',
        method: 'get',
        params: query
    })
}

// 周转补货单支付  代办处
export function poOrderAgentPay(data) {
    return request({
        url: '/agent/poOrderAgentPay',
        method: 'post',
        data
    })
}

// 周转补货单收货  代办处
export function poOrderAgentRec(query) {
    return request({
        url: '/agent/poOrderAgentRec',
        method: 'get',
        params: query
    })
}

// 获取欠货数量  代办处
export function getStockWarehouseAgentsByNo() {
    return request({
        url: '/agent/getStockWarehouseAgentsByNo',
        method: 'get'
    })
}

// 补货单新增  代办处
export function poOrderAgentAdd(data) {
    return request({
        url: '/agent/poOrderAgentAdd',
        method: 'post',
        data
    })
}
